<script setup>
const props = defineProps({
  color:{
    type: String,
    default: '#F8F8F8'
  }
})

const TOKEN_TO_HEX = {
  five01: '#c23535', // 화
  five02: '#404040', // 수
  five03: '#5e9f1c', // 목
  five04: '#949494', // 금
  five05: '#db9823', // 토
  five06: '#ebebeb', // -
}

const normalizeToken = (t) => (t ? t.replace(/^txt-/, '') : t)

const fillColor = computed(() => {
  const c = normalizeToken(props.color)
  // 이미 HEX나 CSS 변수면 그대로 사용
  if (!c) return '#ebebeb'
  if (c.startsWith('#') || c.startsWith('rgb') || c.startsWith('var(')) return c
  return TOKEN_TO_HEX[c] ?? '#ebebeb'
})
</script>
<template>
<svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
  <path d="M17 12.5981C19 11.4434 19 8.55663 17 7.40193L5 0.473722C3 -0.680977 0.499999 0.762399 0.499999 3.0718L0.499999 16.9282C0.499999 19.2376 3 20.681 5 19.5263L17 12.5981Z" :fill="fillColor"/>
</svg>
</template>